import { render, staticRenderFns } from "./MorePie.vue?vue&type=template&id=b1e4e4b8"
import script from "./MorePie.vue?vue&type=script&lang=js"
export * from "./MorePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports